const tryRequire = require('try-require');

module.exports = function (state) {
    const StyleLintPlugin = tryRequire('stylelint-webpack-plugin')
    if (!StyleLintPlugin) {
        return {} // waiting for an installation
    }
    
    const path = require('path')
    return new StyleLintPlugin({
        files: ['src/**/*.s?(a|c)ss', 'src/**/*.less'],
        quiet: true,
        failOnError: false,
        emitErrors: false,
        configFile: path.resolve(state.PROJECT_PATH, './.further/.stylelintrc.json')
    })
}



// WEBPACK FOOTER //
// ./src/technologies/style-lint.js